import { NSAHomePage, NSARouterMakerResult } from "namirasoft-account-react";
import { QuotaLayout } from "../QuotaLayout";
import { QuotaRouterProps } from "../QuotaRouterProps";

interface HomePageProps extends NSARouterMakerResult, QuotaRouterProps { }

export default function HomePage(props: HomePageProps)
{
    return (
        <QuotaLayout {...props} >
            <NSAHomePage {...props} />
        </QuotaLayout>
    )
}